import C from 'classnames';
import React from 'react';
import { TestingProps } from '../../Types/Testing';

interface IButtonGroupProps extends TestingProps {
  className?: string;
  block?: boolean;
  toggle?: boolean;
  children?: React.ReactNode;
}

export const ButtonGroup: React.FunctionComponent<IButtonGroupProps> = (
  props: IButtonGroupProps
) => {
  return (
    <div
      className={C(
        'btn-group',
        props.toggle && 'btn-group-toggle',
        props.block && 'btn-block',
        props.className
      )}
      data-testid={props.testId}
    >
      {props.children}
    </div>
  );
};
